import { common, grey } from '../theme/palette';

// ── Step badge (green numbered circle) ──
export const STEP_BADGE = {
    width: 20, height: 20, borderRadius: '50%',
    background: common.mintyZest, color: '#fff',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '10px', fontWeight: 700, flexShrink: 0,
};

// ── Section card (light gray container) ──
export const SECTION_CARD = {
    background: grey[100], borderRadius: '12px', p: 2,
};

// ── Section header label style ──
export const SECTION_HEADER_LABEL = {
    fontSize: '11px', color: grey[600], textTransform: 'uppercase',
    letterSpacing: '0.5px', fontWeight: 700,
};

// ── Sub-label style (BOOKED WITH, ASSIGNED TO, TIMEFRAME, etc.) ──
export const SUB_LABEL = {
    fontSize: '10px', color: grey[500], textTransform: 'uppercase',
    letterSpacing: '0.3px', fontWeight: 600, mb: 0.75,
};

// ── Chip factory (green active, gray muted, white inactive) ──
export const chipStyle = (isActive, isMuted) => {
    const base = {
        display: 'inline-flex', alignItems: 'center',
        px: 1.5, py: 0.75, borderRadius: '10px',
        fontSize: '13px', fontWeight: 600, cursor: 'pointer',
        transition: 'all 180ms ease', userSelect: 'none', whiteSpace: 'nowrap',
    };
    if (!isActive) return {
        ...base, background: '#fff', color: grey[600],
        border: `1px solid ${grey[300]}24`,
        '&:hover': { borderColor: grey[500], color: grey[800] },
    };
    if (isMuted) return {
        ...base, background: grey[600], color: '#fff',
        border: '1px solid transparent',
        boxShadow: `0 2px 8px ${grey[600]}3D`,
    };
    return {
        ...base, background: common.mintyZest, color: '#fff',
        border: '1px solid transparent',
        boxShadow: `0 2px 8px ${common.mintyZest}3D`,
    };
};

// ── Compact chip (border style, used in booking toggles) ──
export const compactChipStyle = (isActive) => ({
    display: 'inline-flex', alignItems: 'center',
    px: 1.25, py: 0.5, borderRadius: '10px',
    fontSize: '12px', fontWeight: 600, cursor: 'pointer',
    border: '1px solid', transition: 'all 150ms ease',
    userSelect: 'none', whiteSpace: 'nowrap',
    ...(isActive
        ? { borderColor: common.mintyZest, color: common.mintyZest, background: `${common.mintyZest}0F` }
        : { borderColor: `${grey[500]}3D`, color: grey[600], background: 'transparent',
            '&:hover': { borderColor: grey[500], background: grey[100] } }),
});

// ── Icon color for section headers ──
export const SECTION_ICON_COLOR = grey[600];

// ── Avatar selection colors ──
export const AVATAR_COLORS = {
    practitioner: '#078DEE',
    assignee: '#855CF8',
    selected: common.mintyZest,
    selectedBg: `${common.mintyZest}0F`,
};
